/*eslint-disable */
import { bus } from '@/main';
import vistaConfPopup from "./create-vista-conf-popup";
var $ = window.jQuery = require('jquery');
import { mapGetters } from 'vuex';
export default {
  name: 'vista-conference',
  components: {
    'vista-conf' : vistaConfPopup
  },
  props: [],
  data () {
    return {
      vistaConfState:false,
      vistaConfData:null,
      vistaConfDataResults:[]
    }
  },
  computed: {
    ...mapGetters([
      'vistaConferenceGetters',
    ]),
    getVistaConfInfo(){
      this.vistaConfData = this.$store.getters.vistaConferenceGetters.data;
      return
    },
    getVistaConfResults(){
      if(this.vistaConfData){
        this.vistaConfDataResults =  this.vistaConfData.results
      }
    }
  },
  mounted () {
    this.getVistaConfInfo
    this.getVistaConfResults
    bus.$on('vistaConfStateBus', (data) => {
      this.vistaConfState = data
    })
  },
  methods: {
    vistaConfCreatePopup(){
      this.vistaConfState = true
      $('body').addClass('body_right_scroll_remove')
    }
  },
  watch:{
    getVistaConfInfo(){
      return this.$store.getters.vistaConferenceGetters
    },
    getVistaConfResults(){
      if(this.vistaConfData){
        this.vistaConfDataResults =  this.vistaConfData.results
      }
      return
    }
  }
}